import { useTranslation } from "react-i18next";

import { Grid, Icon, Popup } from "semantic-ui-react";
import { styled } from "styled-components";

import { OpenAPI } from "simplydo/interfaces";
import { Input } from "simplydo/react/component-library";

const StyledListItem = styled.div`
  padding: 5px;
  cursor: pointer;
  &:hover {
    background-color: #e9ebee;
  }
`;

type OmniSearcherProps = {
  searchOpen: boolean;
  setSearchOpen: (searchOpen: boolean) => void;
  searchResults?: {
    challenges?: OpenAPI.Schemas["Challenge"][];
    groups?: OpenAPI.Schemas["Group"][];
    polls?: OpenAPI.Schemas["Poll"][];
    ideas?: OpenAPI.Schemas["Idea"][];
  };
  searchTerm: string;
  updateSearchTerm: (searchTerm: string) => void;
  onResultClick: (
    type: string,
    result:
      | OpenAPI.Schemas["Challenge"]
      | OpenAPI.Schemas["Group"]
      | OpenAPI.Schemas["Poll"]
      | OpenAPI.Schemas["Idea"],
  ) => void;
};

const OmniSearcher = ({
  searchOpen,
  setSearchOpen,
  searchResults,
  searchTerm,
  updateSearchTerm,
  onResultClick,
}: OmniSearcherProps) => {
  const { t } = useTranslation();
  return (
    <Popup
      basic
      hoverable
      hideOnScroll
      size="small"
      position="bottom left"
      open={searchOpen}
      onClose={() => setSearchOpen(false)}
      style={{ marginTop: 5, maxHeight: 800, display: "block" }}
      trigger={
        <Input
          value={searchTerm}
          icon="search"
          iconPosition="left"
          style={{ border: "0px", display: "block", margin: "10px 0" }}
          placeholder="Search by name..."
          onChange={(e) => updateSearchTerm(e.target.value)}
          onClick={() => {
            if (searchResults) {
              setSearchOpen(true);
            }
          }}
        />
      }
      content={
        searchResults ?
          <Grid
            stackable
            style={{ padding: 5, paddingBottom: 0, minWidth: 550 }}
          >
            {searchResults?.challenges &&
              searchResults?.challenges?.length > 0 && (
                <Grid.Column width={8}>
                  <h4>
                    {t("common:capitalise", { key: "generic.challenges" })}
                  </h4>
                  {searchResults.challenges.slice(0, 5).map((chall) => (
                    <StyledListItem
                      onClick={() => onResultClick("challenge", chall)}
                      key={chall._id}
                    >
                      <Icon
                        name={"star"}
                        color="grey"
                        style={{ marginRight: 5 }}
                      />
                      {chall?.name}
                    </StyledListItem>
                  ))}
                </Grid.Column>
              )}
            {searchResults?.groups && searchResults?.groups?.length > 0 && (
              <Grid.Column width={8}>
                <h4>Groups</h4>
                {searchResults.groups.slice(0, 5).map((group) => (
                  <StyledListItem
                    onClick={() => onResultClick("group", group)}
                    key={group._id}
                  >
                    <Icon
                      name={"users"}
                      color="grey"
                      style={{ marginRight: 5 }}
                    />
                    {group?.name}
                  </StyledListItem>
                ))}
              </Grid.Column>
            )}
            {searchResults?.polls && searchResults?.polls?.length > 0 && (
              <Grid.Column width={8}>
                <h4>Polls</h4>
                {searchResults.polls.slice(0, 5).map((poll) => (
                  <StyledListItem
                    onClick={() => onResultClick("poll", poll)}
                    key={poll._id}
                  >
                    <Icon
                      name={"lightning"}
                      color="grey"
                      style={{ marginRight: 5 }}
                    />
                    {poll?.name}
                  </StyledListItem>
                ))}
              </Grid.Column>
            )}
            {searchResults?.ideas && searchResults?.ideas?.length > 0 && (
              <Grid.Column width={8}>
                <h4>{t("common:capitalise", { key: "generic.ideas" })}</h4>
                {searchResults.ideas.slice(0, 5).map((idea) => (
                  <StyledListItem
                    onClick={() => onResultClick("idea", idea)}
                    key={idea._id}
                  >
                    <Icon
                      name={"lightbulb"}
                      color="grey"
                      style={{ marginRight: 5 }}
                    />
                    {idea?.name}
                  </StyledListItem>
                ))}
              </Grid.Column>
            )}
          </Grid>
        : null
      }
    />
  );
};

export default OmniSearcher;
